<template>
  <div class="deviceListManagement">
    <div class="top">
      <van-icon size="22px" name="arrow-left" @click="back" />
      <span class="title">{{ $t('append_field.group_list') }}</span>
    </div>
    <div class="content abcds" ref="scrollContainer">
      <div class="scroll-a" v-if="titelData.length>0">
        <div v-for="(it, i) in titelData"
             :key="i"
             class="custom-checkbox">
          <van-cell class="checkbox-content"
                    icon="/static/images/etv-folder.png">
            <div class="ellipsis">
              <span class="name">{{ truncatedName(it.name) }} </span>
              <span style="float: right;">
              <van-icon name="/static/images/terminal/del.png" v-if="it.id !== '1'" style="margin-right: 10px" @click="deleTer(it.id,i)" ></van-icon>
              <van-icon name="/static/images/terminal/exit.png" v-if="it.id !== '1'" @click="exit(it.name,it.id)" ></van-icon>
            </span>
            </div>
          </van-cell>
        </div>
      </div>
      <van-empty
          v-else
          class="custom-image"
          image="/static/images/terminal/empty-img.png"
          :description="$t('append_field.data_empty')"
      />
    </div>
    <div class="btns">
        <van-button color="#006EFF" size="small" @click="dialogShow=true">{{$t('append_field.create')}}</van-button>
    </div>
    <van-dialog v-model="dialogShow"
                :title="title"
                show-cancel-button
                @confirm="onsubmit"
                class="edit-dialog"
                :beforeClose="vBeforeClose"
                @cancel="inputDialogClose">
      <van-row >
        <van-field
            v-model="groupName"
            :label="$t('append_field.name')"
            :placeholder="$t('append_field.ps_push_name')"
            clearable
            style="margin: 40px 0">
        </van-field>
      </van-row>
    </van-dialog>
    <van-overlay :show="overlayShow">
      <div class="wrapper">
            <span class="close" @click="overlayShow = false">
              <van-icon name="cross"/>
            </span>
        <van-loading size="40px">{{$t('append_field.call_device_please_wait')}}</van-loading>
      </div>
    </van-overlay>
    <van-overlay :show="showLoading">
      <div style="height: 100%;display: flex;justify-content: center;align-items: center">
        <van-loading  size="40px" vertical >{{ msg }}...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import qs from 'qs'
import {Dialog, Toast} from 'vant'
import {mapActions} from 'vuex'
import {vBeforeClose} from "@/utils/tool";
import {trim} from "lodash/string";

export default {
  name: 'Terminal',

  inject: ['reload'],
  data() {
    return {
      activeNames: '',
      data: [],
      titelData: [],
      TerminalTop: 0,
      dataList: [],
      doch: 0,
      loading: false,
      finished: false,
      index: 0,
      dialogShow: false,
      groupName: '',
      show: false,
      onlineState: '',
      clientName: '',
      a: 1,
      timeOutEvent: 0,
      longClick: 0,
      deviceNo: '',
      programgroupName: '',
      deviceName: '',
      showPicker: false,
      programShow: false,
      groupingList: [],
      qrCodeData: {
        code: 'dasdsadsd',
      },
      programNameIndex: 0,
      overlayShow: false,
      showLoading: true,
      msg:this.$t('append_field.loadingb'),
      selectedIndex:0,
      typeOptions: [
        { value: '0', label: this.$t('append_field.all') },
        { value: '1', label: this.$t('append_field.online') },
        { value: '-1', label: this.$t('append_field.offline') },
      ],
      selectedType:'0',
      title:this.$t('append_field.create_terminal_group'),
    }
  },

  mounted() {
    document.title = this.$t('append_field.terminal_management')
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    this.doch = window.screen.height
    const scrollContainer = document.getElementsByClassName('abcds')[0]
    scrollContainer.addEventListener('scroll', this.handleScroll2);
    this.showLoading=true
    this.getData()

  },
  methods: {
    vBeforeClose,
    ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),

    handleResize() {
      // 获取底部导航栏元素
      const tabbar = document.querySelector('.van-tabbar')
      tabbar.style.display = 'none'
    },
    gotouchstart(item, index) {
      clearTimeout(this.timeOutEvent)//清除定时器
      this.timeOutEvent = 0
      this.longClick = 0
      //默认分组不可删除
      if (item.id === "1") {
        return
      }

      this.timeOutEvent = setTimeout(() => {
        this.longClick = 1
        Dialog.confirm({
          title: this.$t('append_field.delete_group'),
          message: this.$t('append_field.confirm_delete_group'),
        }).then(() => {
          this.$ajax.post('/etv/deleteGroupById.json', qs.stringify({
            id: item.id,
          })).then(res => {
            if (res.data.code === 0) {
              Toast(this.$t('append_field.delete_success'))
              this.titelData.splice(index, 1)
            }
            Toast(res.data.msg)
          })
        }).catch(() => {
        })

      }, 700)//这里设置定时
    },
    //手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    gotouchend() {
      clearTimeout(this.timeOutEvent)

    },
    //如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gotouchmove() {
      clearTimeout(this.timeOutEvent)//清除定时器
      this.timeOutEvent = 0
    },
    getChea(index) {
      this.index = 0
      if (index === '') {
        return
      }
      this.selectedIndex = index
      //重置滚动位置
      this.$refs.scrollContainer.scrollTop = 0
      this.activeNames = index
      this.data = this.dataList[this.activeNames].children.slice(this.index,this.index + 15)
    },
    truncatedName(fullName) {
      // 截断名称并确保括号内容完整显示
      const namePart = fullName.split(' (')[0];
      const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : '';

      // 判断是否为英文名（假设英文名不包含中文字符）
      const isEnglish = /^[A-Za-z\s]+$/.test(namePart);

      // 根据是否为英文名选择不同的截断长度
      const maxLength = isEnglish ? 16: 6;

      if (namePart.length <= maxLength) {
        return fullName;
      } else {
        return `${namePart.substring(0, maxLength)}...${infoPart}`;
      }
    },
    onprogramShow() {
      let str = this.qrCodeData.code
      if (!this.groupingList[this.programNameIndex].id) {
        Toast(this.$t('append_field.pel_select_group'))
        return
      }

      if (this.deviceName === '') {
        Toast(this.$t('append_field.enter_device_name'))
        return
      }

      this.$ajax.post('/etv/insertPhoneClient.json', qs.stringify({
        clName: this.deviceName,
        clNo: str,
        clGpId: this.groupingList[this.programNameIndex].id,
      })).then(res => {
        this.showPicker = false
        this.programShow = false
        if (res.data.code === 0) {
          Toast(this.$t('append_field.add_success'))
        } else {
          Toast(res.data.msg)
        }
      })
    },
    getData(onlineState = '', clientName = '', groupParentId = '', type = '') {
      this.msg = this.$t('append_field.loadingb')
      this.$ajax.post('/etv/selectSeachClientTreeMobile.json', qs.stringify({
        groupParentId,
        type,
        onlineState,
        clientName,
      })).then(res => {
        this.titelData = []
        this.dataList = []
        if (res.data.code === 0) {
          res.data.data.map((res) => {
            this.titelData.push({id: res.id, name: res.name})
          })
          this.dataList = res.data.data
          // 默认加载第一个按钮的设备列表
          if(this.index === -1) this.index = 0
          this.activeNames=this.activeNames?this.activeNames:0
          if(this.dataList.length !== 0 ){
            this.data = this.dataList[this.activeNames].children.slice(this.index, this.index + 15)
          }else {
            this.data=[]
          }

          this.$nextTick(() => {
            this.showLoading = false
          })
        }
      })
    },
    onConfirm(value, index) {
      this.showPicker = false
      this.programgroupName = value
      this.programNameIndex = index
    },
    handleScroll2() {
      const scrollHeight = document.getElementsByClassName('content')[0].scrollTop;
      const clientHeight = document.getElementsByClassName('abcds')[0].clientHeight;
      const doch = document.getElementsByClassName('content')[0].clientHeight;

      if (clientHeight - doch - scrollHeight < 10) {

        const children = this.dataList[this.activeNames].children
        if (children.slice(this.index * 15, this.index * 15 + 15).length < 15) {
          return
        }
        this.index++
        this.data = [...new Set([...this.data, ...children.slice(this.index * 15, this.index * 15 + 15)])]
      }
    },

    deleTer(id,index) {
      Dialog.confirm({
        title: this.$t('append_field.delete_group'),
        message: this.$t('append_field.confirmDeleteGroup'),
      }).then(() => {
        this.$ajax.post('/etv//deleteGroupById.json', qs.stringify({
          id: id,
        })).then(res => {
          if (res.data.code === 0) {
            Toast(res.data.msg)
            this.titelData.splice(index, 1)
          }else {
            Toast(res.data.msg)
          }
        })
      }).catch(() => {

      })
    },

    exit(name,id) {
      this.dialogShow=true
      //去除两端的空白字符，提取分组名称
      this.groupName=trim(name.substring(0,name.indexOf('(')))
      this.id=id
      this.title=this.$t('append_field.exit_group_name')
    },

    onsubmit() {
      if(this.title===this.$t('append_field.create_terminal_group')){
        this.$ajax.post('/etv/insertGroup.json', qs.stringify({
          groupName: this.groupName,
          groupParentId: -1,
          groupDescp: '',
        })).then(res => {
          if (res.data.code === 0) {
            this.reload()
          } else {
            Toast(res.data.msg)
          }
        })
      }else {
        this.$ajax.post('/etv/updateClientNameOrGroupName.json', qs.stringify({
          name: this.groupName,
          id: this.id,
          type: "group"
        })).then(res => {
          if (res.data.code === 0) {
            this.reload()
          } else {
            Toast(res.data.msg)
          }
        })
      }

    },

    getContainer() {
      return document.querySelector('.Terminal')
    },

    onSearch() {
      this.getData(this.onlineState, this.clientName)
      this.show = false
    },

    open() {
      this.show = true
    },

    close() {
      this.show = false
      this.inputDialogClose()
    },

    getType(type) {
      this.selectedType=type
      this.onlineState = type
    },
    inputDialogClose() {
      console.log(159);
      this.dialogShow = false
      this.show = false
      this.groupName = ''
    },
    back() {
      this.$router.back()
    }
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.deviceListManagement{

  height: 100% !important;
  overflow:hidden;
  .top{
    padding:18px 10px;
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    justify-content: center; /* 水平居中对齐 */
    position: relative; /* 使子元素可以相对于父元素定位 */
    border-bottom: #8c8c8c 1px solid;

    .van-icon {
      position: absolute; /* 绝对定位 */
      left: 10px; /* 根据需要调整左边距 */
    }
    .title{
      font-size: 18px;
      font-size: 18px;
      float: none; /* 确保不使用浮动 */
      display: inline-block; /* 使元素成为行内块级元素 */
    }
  }
  .van-field{
    .van-field__label{
      width: 60px;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    /*height: calc(100% - 70px);*/
    position: relative;

    .close {
      top: 10px;
      right: 10px;
      position: absolute;

      i {
        color: white;
      }
    }
  }

  .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
  }
  .btn-list{
    display: flex;
    overflow-x: auto; /* 水平滚动 */
    align-items: center;
    justify-content: flex-start;
    gap: 10px; /* 按钮之间的间隔 */
    height: 60px;
    border-bottom: 1px solid #707070;
    .terminal-btn{
      background-color: white;
      color: black;
      border: 1px solid #ddd; /* 可选：添加边框以便更清晰地看到按钮 */
    }
    .van-button__text{
      display: block;
      max-width: 100%;
      white-space: nowrap; /* 确保文本在一行显示 */
      overflow: hidden; /* 超出容器部分隐藏 */
      text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    }
    .selected {
      background-color: #006EFF ;
      color: white;
    }
  }
  .content {
    height: calc(100% - 60px - 60px );
    overflow-y: auto; /* 水平滚动 */

    .van-cell {
      padding: 10px 10px 0 10px;
      line-height: 30px;
      font-size: 16px;

    }

    .checkbox-content {
      display: flex;
      align-items: center;
      .ellipsis {
        width: 100%; /* 根据需要调整宽度 */
        display: flex;
        justify-content: space-between; /* 水平分布子元素 */
        align-items: center; /* 垂直居中对齐子元素 */
        .name{
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

        }
        .van-icon__image{
          width: 40px;
          height: 40px;
        }
      }
      .van-cell__left-icon{
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .van-icon__image{
        width: 26px;
        height: 26px;
      }
    }

    .van-collapse-item__title--expanded {
      background: $uni-color-primary;
      color: #ffffff;
    }

    .van-collapse-item__content {
      padding: 0;
    }

    .item-child {
      list-style: none;
      padding: 0 16px;

      li {
        padding: 10px 0;
        line-height: 30px;
        position: relative;
        display: flex;
        justify-content: space-between;
        font-size: 16px;

        button {
          line-height: 22px;
        }

        img {
          height: 24px;
          margin-right: 10px;
        }

        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: 1px solid $uni-border-bottom-color;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

      li:nth-last-child(1) {
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -50%;
          bottom: -50%;
          left: -50%;
          border-bottom: none;
          -webkit-transform: scale(.5);
          transform: scale(.5);
        }
      }

    }


  }

  .btns {
    display: flex;
    height: 40px;
    justify-content: center;
    align-items: center;
    padding: 10px 15px;

  }

  .a {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .popup-title {
    height: 30px;
    line-height: 30px;
    padding-left: 15px;
  }

  .popup-btns {
    margin-top: 15px;
    padding: 0 15px;
  }

  .button-btns {
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .van-button--mini {
    font-size:  16px;
    height: 30px;
    box-sizing: border-box;
  }

  .van-cell__right-icon {
    color: white;
    line-height: 30px !important;
  }

  .van-cell__left-icon, .van-cell__right-icon {
    height: 30px;
    font-size: 16px !important;
    line-height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
  }
  .edit-dialog{
    .van-field__body{
      border-bottom: black 1px solid;
    }
    .van-field__label{
      width: 100%;
    }
    .van-cell{
      display: flex;
      flex-direction: column;
    }

  }
}
</style>
